import {STATE_MA} from '../states/state.const';

export const COUNTY_BARNSTABLE = {_id: '507f1f77bcf86cd799439011', label: 'Barnstable County'};
export const COUNTY_BERKSHIRE = {_id: '507f1f77bcf86cd799439012', label: 'Berkshire County'};

export const COUNTY_BRISTOL = {
    _id: '507f1f77bcf86cd799439013',
    label: 'Bristol County',
};

export const COUNTY_DUKES = {
    _id: '507f1f77bcf86cd799439014',
    label: 'Dukes County',
};

export const COUNTY_ESSEX = {
    _id: '507f1f77bcf86cd799439015',
    label: 'Essex County',
};

export const COUNTY_FRANKLIN = {
    _id: '507f1f77bcf86cd799439016',
    label: 'Franklin County',
};

export const COUNTY_HAMPDEN = {
    _id: '507f1f77bcf86cd799439017',
    label: 'Hampden County',
};

export const COUNTY_HAMPSHIRE = {
    _id: '507f1f77bcf86cd799439018',
    label: 'Hampshire County',
};
export const COUNTY_MIDDLESEX = {
    _id: '507f1f77bcf86cd799439019',
    label: 'Middlesex County',
};
export const COUNTY_NANTUCKET = {
    _id: '507f1f77bcf86cd799439020',
    label: 'Nantucket County',
};
export const COUNTY_NORFORK = {
    _id: '507f1f77bcf86cd799439021',
    label: 'Norfolk County',
};
export const COUNTY_PLYMOUTH = {
    _id: '507f1f77bcf86cd799439022',
    label: 'Plymouth County',
};
export const COUNTY_SUFFOLK = {
    _id: '507f1f77bcf86cd799439023',
    label: 'Suffolk County',
};
export const COUNTY_WORCESTER = {
    _id: '507f1f77bcf86cd799439024',
    label: 'Worcester County',
};

export const COUNTY_OUT_OF_STATE = {
    _id: '507f1f73bcf26cd729231025',
    label: 'Out of State',
};

export const COUNTY_OTHER = {
    _id: '507f1f77bcf86cd799439025',
    label: 'Other',
};

export const COUNTIES = [
    //
    COUNTY_BARNSTABLE,
    COUNTY_BERKSHIRE,
    COUNTY_BRISTOL,
    COUNTY_DUKES,
    COUNTY_ESSEX,
    COUNTY_FRANKLIN,
    COUNTY_HAMPDEN,
    COUNTY_HAMPSHIRE,
    COUNTY_MIDDLESEX,
    COUNTY_NANTUCKET,
    COUNTY_NORFORK,
    COUNTY_PLYMOUTH,
    COUNTY_SUFFOLK,
    COUNTY_WORCESTER,
    COUNTY_OUT_OF_STATE,
    COUNTY_OTHER,
].map(d => ({...d, state: STATE_MA.abbreviation}));
